import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { getAccessToken } from "@/utils/auth";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import SvgIcon from "@/components/common/SvgIcon";
import VueAwesomeSwiper from "vue-awesome-swiper";
import {
  Swiper as SwiperClass,
  Mousewheel,
  Pagination,
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
SwiperClass.use([Pagination, Mousewheel]);
Vue.use(getAwesomeSwiper(SwiperClass));
import "swiper/swiper-bundle.css";
import VueAnime from "vue-animejs";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faUser, faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faLinkedinIn,
  faYoutube,
  faTwitter,
  faWeixin,
  faLine,
} from "@fortawesome/free-brands-svg-icons";
import VueEasyLightbox from "vue-easy-lightbox";
Vue.use(VueEasyLightbox);
import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);
import {
  faUser as fasUser,
  faGlobeEurope,
  faExclamationCircle,
  faQuestionCircle as fasQuestionCircle,
  faChevronRight,
  faChevronLeft,
  faSortDown,
  faCaretRight,
  faPhone,
  faEnvelope,
  faBars,
  faSearch,
  faChevronUp,
  faComments,
  faCogs,
  faEye,
  faCamera,
  faShareAlt,
} from "@fortawesome/free-solid-svg-icons";
Vue.use(VueAnime);
Vue.use(VueAwesomeSwiper);
Vue.use(BootstrapVue);
library.add(
  faGlobeEurope,
  faUser,
  fasUser,
  faExclamationCircle,
  fasQuestionCircle,
  faChevronRight,
  faChevronLeft,
  faSortDown,
  faCaretRight,
  faPhone,
  faEnvelope,
  faLinkedinIn,
  faYoutube,
  faBars,
  faSearch,
  faChevronUp,
  faComments,
  faQuestionCircle,
  faCogs,
  faEye,
  faCamera,
  faShareAlt,
  faTwitter,
  faWeixin,
  faLine
);
Vue.component("font-awesome-icon", FontAwesomeIcon); //使用kebab-case

Vue.component("svg-icon", SvgIcon);

require("vue-ionicons/ionicons.css");

import VueMeta from "vue-meta";
Vue.use(VueMeta);

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
const req = require.context("@/icons", true, /\.svg$/);
requireAll(req);

Vue.config.productionTip = false;

import { tracking_logs } from "@/api/track";

router.beforeEach(async (to, from, next) => {
  tracking_logs({ path: to.path });
  const hasToken = getAccessToken();
  if (hasToken) {
    try {
      await store.dispatch("user/getInfo");
      next();
    } catch (error) {
      store.dispatch("user/logout");
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
